import { axiosInstance } from "@/helper/axios-instance";
import { useMutation } from "@tanstack/react-query";

type Args = {
  clientCode?: string;
  externalCode?: string;
  fileName: string;
  showRoR: boolean;
  showSS: boolean;
  contentType?: string;
  showHiddenRows: boolean;
  upData?: string;
};

export function useUPPrint() {
  return useMutation({
    mutationFn: async ({
      clientCode,
      externalCode,
      fileName,
      showRoR,
      showSS,
      showHiddenRows,
      upData,
    }: Args) => {
      const response = await axiosInstance({
        method: "POST",
        responseType: "arraybuffer",
        data: {
          clientCode,
          externalCode,
          fileName,
          showRoR,
          showSS,
          showHiddenRows,
          upData,
        },
        url:  `Salesforce/PrintUniquePossibilities`,
      });
      return { response, fileName };
    },
    onSuccess: (data) => {
      const { response, fileName } = data;

      const blob = new Blob([response.data], { type: "application/octetstream" });

      const url = window.URL || window.webkitURL;
      const link = url.createObjectURL(blob);
      const a = document.createElement("a");

      a.setAttribute("download", fileName);
      a.setAttribute("href", link);
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
  });
}
